import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchJobWorks,
    getJobWorks,
} from '../../app/reducers/JobWork/jobWorkSlice';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import moment from 'moment';
import JobWorkDetailsModal from './JobWorkDetailsModal';
import { Edit2, Printer, Trash2 } from 'react-feather';
import { deleteJobWork } from '../../app/api/jobWork';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { authAxiosInstance } from '../../utils/axiosConfig';

const ViewJobWork = () => {
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const { jobWork, loading } = useSelector(getJobWorks);
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    console.log('jobWork', jobWork);

    const dispatch = useDispatch();

    const col = [
        // {
        //     Header: 'Select',
        //     Cell: ({ row }) => {
        //         return (
        //             <input
        //                 type="checkbox"
        //                 checked={selectedRows?.some(
        //                     (ele) => ele?._id === row?.original?._id
        //                 )}
        //                 onChange={(e) => {
        //                     e.currentTarget.checked;
        //                     if (e.currentTarget.checked) {
        //                         setSelectedRows([
        //                             ...selectedRows,
        //                             row?.original,
        //                         ]);
        //                     } else {
        //                         const filtered = selectedRows?.filter(
        //                             (ele) => ele?._id !== row?.original?._id
        //                         );
        //                         setSelectedRows(filtered);
        //                     }
        //                 }}
        //             />
        //         );
        //     },
        // },
        {
            Header: 'Job Work No.',
            accessor: 'jobWorkNumber',
        },
        {
            Header: 'Vendor Name',
            accessor: 'vendorName',
        },
        {
            Header: 'Date',
            Cell: ({ row }) => {
                console.log('row',row?.original)
                return (
                    <div>
                        {moment(row?.original?.date).format('DD-MM-YYYY')}
                    </div>
                );
            },
        },
        {
            Header: 'Status',
            accessor: 'status',
        },
        {
            Header: 'Job Work Details',
            Cell: ({ row }) => {
                return (
                    <div
                        className="text text-blue-400 hover:text-blue-700 cursor-pointer truncate"
                        onClick={(e) => {
                            e.stopPropagation();
                            setDetailsModalOpen(true);
                            setData(row?.original?.jobDetails);
                            setDetailsModalOpen(true);
                            setData(row?.original?.jobDetails);
                        }}
                    >
                        View Job Work Details
                    </div>
                );
            },
        },
        {
            Header : 'Notes',
            accessor : 'notes'
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-row items-center gap-2">
                        <Edit2
                            className="cursor-pointer"
                            size={18}
                            color="blue"
                            onClick={async (e) => {
                                e.stopPropagation();
                                navigate(`/editJobWork/${row.original?._id}`);
                            }}
                        />
                        <Trash2
                            className="cursor-pointer"
                            size={18}
                            color="red"
                            onClick={async (e) => {
                                e.stopPropagation();
                                await deleteJobWork(row.original._id);
                                dispatch(fetchJobWorks({ page: 1 }));
                            }}
                        />
                        <Printer
                            className="cursor-pointer"
                            size={18}
                            onClick={async (e) => {
                                e.stopPropagation();
                                const response = await authAxiosInstance.post(
                                    `/jobWork/jobWorkPdf`,
                                    row?.original
                                );
                                const printWindow = window.open('', '_blank');
                                printWindow.document.write(response.data);
                            }}
                        />
                    </div>
                );
            },
        },
    ];
    const jobWorkData = useMemo(() => {
        if (jobWork && jobWork?.docs?.length) return jobWork?.docs;
        else return [];
    }, [jobWork]);

    useEffect(() => {
        dispatch(fetchJobWorks({ page }));
    }, []);

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            dispatch(fetchJobWorks({ search: search, page }));
        }, 300)
    );
    return (
        <PageWithCard>
            <JobWorkDetailsModal
                detailsModalOpen={detailsModalOpen}
                setDetailsModalOpen={setDetailsModalOpen}
                data={data}
            />
            <TableWithHeadingAndGlobalSearch
                columns={col}
                data={jobWorkData}
                loading={loading}
                searchFunction={debouncedSearch}
                heading={'View Job Work'}
            />
            <PaginationClassic paginationDetails={jobWork} setPage={setPage} />
        </PageWithCard>
    );
};

export default ViewJobWork;
